module.exports = __webpack_public_path__ + "static/light-bulb-90cc547dae9098a62f2a010440a5f003.png";